import * as ResourceApi from "../../../api/resources";
import * as ResourceActions from "../../../resources/actions";
import * as Actions from "./actions";
import {endEditBreakTagAction} from "./actions";
import {Observable} from "rxjs";
import {createdResourceAction} from "../../../resources/actions";
import {SupportedLangs} from "../../../utils/DBUtils";

const createBreakTagEpic = (action$, store) => action$.ofType(Actions.Types.SUBMIT_BREAK_TAG_EDIT)
    .mergeMap((action) => {
        const breakTagModal = store.getState().breakTagModal;

        if (breakTagModal.editingTag) {
            let changelist = [];
            let tag = breakTagModal.tag;
            let original = breakTagModal.originalTag;

            if (tag.label !== original.label) {
                changelist.push({
                    field: "label",
                    value: tag.label
                });
            }

            for (let lang of SupportedLangs) {
                let next = tag.translations[lang];
                let orig = original.translations[lang];

                if (next !== orig) {
                    changelist.push({
                        field: `translations.${lang}`,
                        value: next
                    });
                }
            }

            return ResourceApi.saveChangelist(
                ResourceApi.Types.BreakTag,
                tag.id,
                changelist,
                [tag.resourceId],
                {}
            ).mergeMap(() => {
                return Observable.of(
                    ResourceActions.saveResourceChangelistSuccess(ResourceApi.Types.BreakTag,
                        tag.id,
                        changelist,
                        tag.resourceId.id),
                    endEditBreakTagAction()
                );
            }).catch((error) => Observable.of({type: "ERROR", error}));
        } else if (breakTagModal.creatingTag) {
            return ResourceApi.create(ResourceApi.Types.BreakTag, {
                ...breakTagModal.tag
            }, [])
                .mergeMap(({response: {object}}) => {
                    let actions = [
                        endEditBreakTagAction(),
                        createdResourceAction(object, object, object.resourceId, [], [], null)
                    ];

                    if (breakTagModal.postCreateAction) {
                        actions.push({type: breakTagModal.postCreateAction, tag: object});
                    }

                    return Observable.of(...actions)
                })
                .catch((err) => {
                    return Observable.of({type: "EMPTY"})
                });
        }
    });

export default [
    createBreakTagEpic,
];



// WEBPACK FOOTER //
// ./public/pages/EditBreak/BreakTagModal/epics.js